import { render, staticRenderFns } from "./kjxj-list.vue?vue&type=template&id=6acda87c&scoped=true&"
import script from "./kjxj-list.vue?vue&type=script&lang=js&"
export * from "./kjxj-list.vue?vue&type=script&lang=js&"
import style0 from "./kjxj-list.vue?vue&type=style&index=0&id=6acda87c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acda87c",
  null
  
)

export default component.exports